import React, { useContext } from 'react'
import { DataSupportAssuranceContext } from '../types'
import { InputElement } from '../../../../HtmlComponents/InputElement'

const InputsSupportAssurance = () => {
  const {
    amount, setAmount,
    createdAt, setCreatedAt
  } = useContext(DataSupportAssuranceContext)
  return (
    <>
      <InputElement name='Montant' value={amount} setValue={setAmount}/>
      <InputElement type='date' name='Date' value={createdAt} setValue={setCreatedAt}/>
    </>
  )
}

export default InputsSupportAssurance